import DatatableComponent from "../../../../../../components/common/DatatableComponent/DatatableComponent"

const OtherCharges = () => {
  const data = [
    { label: "Standard Shipping", value: "$5 per order" },
    { label: "Express Shipping", value: "$10 per order" },
    { label: "Storage Fees", value: "$0.50 per cubic foot per month" },
    { label: "Handling Fees", value: "$1 per item" },
  ]

  const columns = [
    { name: 'Service Type', selector: row => row.label },
    { name: 'Fee Structure', selector: row => row.value },
  ]

  return (
    <div>
      <div className="fw-semibold fs-5">Other Charges</div>

      <div className="px-5 py-2">
        <DatatableComponent data={data} columns={columns} type="yellow" />
      </div>
    </div>
  )
}

export default OtherCharges
